import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/account-error-message')({
  beforeLoad: () => {
    throw redirect({
      to: '/n/account-error-message',
      replace: true,
    });
  },
});
